<template>
  <div class="group relative flex flex-nowrap items-center justify-center">
    <CustomButton
      class="flex flex-nowrap items-center justify-center w-10 lg:w-auto"
      type="raw"
      data-testid="contact-button"
      :aria-label="$t('Contact')"
      @click="() => openContactForm()"
    >
      <span class="iconify svg--contact text-base text-EXPONDO-primary lg:mr-3" />
      <div class="text-left hidden whitespace-nowrap text-EXPONDO-primary lg:block">
        <p class="font-bold">
          {{ $t('Contact') }}
        </p>
        <p class="text-xs font-normal">
          {{ $t('salesforce-form-submit-an-issue') }}
        </p>
      </div>
    </CustomButton>
    <div
      class="max-lg:hidden invisible opacity-0 min-w-[200px]
        lg:group-hover:visible lg:group-hover:opacity-100
        transition-all [transition-behavior:allow-discrete] duration-[400ms]
        absolute top-full left-0 z-40"
    >
      <div class="fixed top-0 left-0 bg-EXPONDO-black/25 w-full h-full pointer-events-none" />
      <div class="relative bg-EXPONDO-white text-EXPONDO-black font-normal text-left mt-3 shadow-2xl text-sm border ">
        <button
          v-for="(reason, index) in webformSpecificReasons"
          :key="reason.indicator"
          class="block w-full text-left px-4 py-2 border-b cursor-pointer hover:bg-EXPONDO-grey-5"
          :data-testid="`preselected-reason-${index}`"
          @click="() => openContactForm(reason.indicator)"
        >
          {{ reason.indicator ? $t(`${reason.indicator}-label`): '' }}
        </button>
        <div
          v-if="showContactInfo"
          class="flex justify-center items-center gap-x-2 px-4 py-7 bg-EXPONDO-grey-10"
        >
          <PhoneNumber
            v-if="showPhoneNumber"
            :phone-number="contactInformation.phoneNumber"
            class="font-bold leading-4"
          />
          <div
            v-if="showWorkingHours"
            class="whitespace-nowrap"
          >
            <span>{{ contactInformation.openingHours }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">

import { getSalesforceWebformSpecificReasons } from '~~/helpers/salesforce/salesforce';
import type { SalesforceFormIndicatorValue } from '~~/types/salesforce';

export default defineComponent({
  name: 'WebformDropdown',
  emits: ['openContactForm'],

  setup(_, { emit }) {

    const { contactInformation } = useStoreVsfExtended();
    const { countryCode } = useLocalization();

    const showPhoneNumber = computed(() => !!contactInformation.value.phoneNumber);
    const showWorkingHours = computed(() => contactInformation.value.openingHours && showPhoneNumber.value);

    const showContactInfo = computed(() => showPhoneNumber.value || showWorkingHours.value);

    const webformSpecificReasons = computed(() => {

      return getSalesforceWebformSpecificReasons(countryCode.value);
    
    });

    const openContactForm = (reason?: SalesforceFormIndicatorValue): void => {

      emit('openContactForm', reason);
    
    };

    return {
      openContactForm,
      showContactInfo,
      showPhoneNumber,
      showWorkingHours,
      webformSpecificReasons,
      contactInformation,
    };
  
  },
});

</script>
